var map = {
	"./cover-conway.png": "443c",
	"./cover-netsharer.png": "510e",
	"./cover-recipy.png": "954e",
	"./cover-recipyapi.png": "93af",
	"./cover-socialphoto.png": "da6b",
	"./logo_sr_descripcion.png": "995b",
	"./me.jpeg": "11db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";